import LocationSpaceDetailsCard from "./LocationSpaceDetailsCard";
import { LocationSpaceDetailsCardContent, LocationSpaceDetailsCardHeaderRight } from "./SubComponents";
import { ILocationSpaceDetailsCard } from "./ILocationSpaceDetailsCard";


const LocationSpaceDetailsCardComponent = LocationSpaceDetailsCard as unknown as React.FC<ILocationSpaceDetailsCard> & {
  Content: typeof LocationSpaceDetailsCardContent;
  HeaderRight: typeof LocationSpaceDetailsCardHeaderRight;
};

LocationSpaceDetailsCardComponent.Content = LocationSpaceDetailsCardContent;
LocationSpaceDetailsCardComponent.HeaderRight = LocationSpaceDetailsCardHeaderRight;

export type { ILocationSpaceDetailsCard };
export default LocationSpaceDetailsCardComponent;
